/* ============
 * VMP Sync Fields Popup
 * ============
 *
 */

import { mapGetters, mapMutations } from 'vuex';
import productPackagingService from '../../services/productPackaging';

export default {
  props: {
    productsNoPackaging: {
      required: true,
      type: Array,
      default: [],
    },
    onConfirm: {
      required: true,
      type: Function,
      default: () => {},
    },
    onUpdatePackaging: {
      required: true,
      type: Function,
      default: () => {},
    },
    onPackagingCreate: {
      required: true,
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      products: [],
    };
  },

  computed: {
    ...mapGetters({
      productPackagings: 'allProductPackagings',
    }),
    hasProductWithNoPackaging() {
      return this.products.filter(p => !p.productPackagingId).length;
    },
  },

  created() {
    this.loading = true;
    productPackagingService
      .all()
      .then(() => {
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
    this.products = this.productsNoPackaging.map(p => Object.assign({}, p));
  },

  watch: {},

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalProps: 'SET_MODAL_PROPS',
      setModalSize: 'SET_MODAL_SIZE',
      setModalClass: 'SET_MODAL_CLASS',
    }),

    addNewPackaging(product) {
      this.setModalContent(() =>
        require('./../../pages/withNavigation/productPackagings/create/create.vue')
      );
      this.setModalSize('full');
      this.setModalClass('');
      this.setModalProps({
        onClose: this.onPackagingCreate,
        suggestedData: product,
      });
    },

    confirm() {
      this.loading = false;
      this.onConfirm();
      this.closeModal();
    },
    /*
     * Closes the modal
     */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
  components: {
    VForm: require('./../../components/form/form.vue'),
    VMessage: require('./../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/vmpSyncPackagingPopup/vmpSyncPackagingPopup.js